import backend from '../index'

export default async function getConfigs() {
  const configs = await backend.get(`/configs`)
  return configs.data
}
